import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import type { RouteProps } from 'react-router-dom';

import { useAuth } from '../../hooks';
import { PermissionCheck } from '../../shared';
import { DynamicPageTitle } from '../DynamicPageTitle';

type ProtectedRouteProps = Omit<
  RouteProps,
  'render' | 'component' | 'children'
> & {
  title?: React.ReactNode;
  action?: SpPermission | SpPermission[];
  children?: React.ReactNode;
  component?: React.ComponentType;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  title,
  action,
  children,
  component: Component,
  ...rest
}) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return null;
  if (!isAuthenticated) return <Redirect to="/login" />;

  const element = (
    <>
      {<DynamicPageTitle>{title}</DynamicPageTitle>}
      {Component ? <Component /> : children}
    </>
  );

  if (!action || !action.length) {
    return <Route {...rest} children={element} />;
  }

  return (
    <Route {...rest}>
      <PermissionCheck action={action} fallback={<Redirect to="/404" />}>
        {element}
      </PermissionCheck>
    </Route>
  );
};

export default React.memo(ProtectedRoute);
